import apiCall from '../apiCall';
import store from '@/store';
import moment from 'moment';

/**
 * Suspends user account
 *
 * @param {object} instance Vue instance.
 */
export default async (instance) => {
    const { status: cancelStatus } = await apiCall(instance, 'delete', `/api/billing/subscriptions/${instance.userSubscription.dbId}`);
    const { status: suspendStatus } = await apiCall(instance, 'post', '/api/user/suspension', { suspension: moment().unix() });

    if (200 === cancelStatus && 200 === suspendStatus) {
        instance.formProcessing = true;

        instance.updateUser()
            .then(async () => {
                await store.dispatch('loadUserSubscription', { force: true });

                instance.formProcessing = false;

                instance.changeUIState({ isFinishCancelationView: true });
                instance.changeUIState({ isCancelModalVisible: false });
            })
            .catch(() => {
                instance.formProcessing = false;

                instance.toastError({
                    message: {
                        title: 'We couldn\'t cancel Your subscription. Please contact us, or try again later',
                    },
                });
            });
    } else {
        instance.formProcessing = false;

        instance.toastError({
            message: {
                title: 'We couldn\'t cancel Your subscription. Please contact us, or try again later',
            },
        });
    }
};
